// @ts-nocheck
import { getBlogCategoryArticlesParameter } from "@store/Framework/Store/Starter/Pages/BlogCategory/BlogCategorySelector";
import convertSelectorToHook from "@store/Framework/Common/Utilities/convertSelectorToHook";

export const useBlogCategoryArticlesParameter = convertSelectorToHook(getBlogCategoryArticlesParameter);
